<template>
  <div class="bg-green-400 w-screen">

    <section class="bg-white py-5">
          <div class="max-w-4xl mx-auto px-4 py-6 sm:py-6 md:py-6 lg:pt-6 lg:pb-6">
            <FAQ
              v-for="(element, i) in tyc"
              :index="i"
              :key="i"
              :title="element.title"
              :open="element.open"
              :tyc_title="element.tyc_title"
              @toggleOpen="toggleOpen">

                <div v-html="element.content"></div>

            </FAQ>
      </div>
    </section>
     <div
      class="
        max-w-6xl
        m-auto
        text-center
        content-center
        items-center
        justify-center
        flex flex-col
        md:flex-row
        py-10
      "
    >
      <p class="text-white px-2">{{ footerTranslate[language].title }}</p>
      <p class="text-white text-lg px-2 mt-5 sm:mt-0">
        <a
          href="https://www.vivaaerobus.com/mx/info/terminos-y-condiciones-completos#b19-0"
          target="_blank"
          class="font-bold underline"
          >{{ footerTranslate[language].linkText }}</a
        >
      </p>
    </div>
  </div>
  <div class="bg-green-500 h-52">
    <div
      class="
        max-w-6xl
        flex flex-wrap
        justify-between
        text-white
        items-center
        mx-auto
        pt-10
        xs:text-center
        sm:text-center
      "
    >
      <div class="md:w-6/12 md:text-left xs:w-full sm:w-full">
        <p>{{ footerTranslate[language].accept }}</p>
        <p>{{ footerTranslate[language].cc }}</p>
      </div>
      <div
        class="
          md:w-6/12 md:text-right
          sm:text-center
          xs:text-center
          sm:my-2
          xs:w-full
          sm:w-full
        "
      >
        <p>
          Aeropuerto Internacional de Monterrey. Terminal C, Carretera Miguel
          Alemán Km 24, Apodaca, NL, México, C.P. 66600
        </p>
      </div>
      <div
        class="w-full text-26 mt-2 xs:text-center sm:text-center md:text-left"
      >
        <FontAwesomeIcon :icon="faCcMastercard" />
        <FontAwesomeIcon :icon="faCcAmex" class="mx-3" />
        <FontAwesomeIcon :icon="faCcVisa" />
      </div>
    </div>
  </div>
</template>
<script>
import { footerTranslate } from "@/translations/Footer.js";
import { computed,ref } from "@vue/reactivity";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { tycTranslate } from '@/translations/TYC.js';
import FAQ from "@/components/Accordion.vue";
import {
  faCcAmex,
  faCcVisa,
  faCcMastercard,
} from "@fortawesome/free-brands-svg-icons";

export default {
  components: {
    FontAwesomeIcon,
    FAQ,
  },
  setup() {
    const language = computed(() => {
      return localStorage.getItem("viva-translate")
        ? localStorage.getItem("viva-translate")
        : "es";
    });

    const tyc = ref([
      ...tycTranslate[language.value].content,
    ])

    return { language, footerTranslate, faCcAmex, faCcVisa, faCcMastercard, tyc };
  },
  methods: {
    toggleOpen: function (index) {
      this.tyc = this.tyc.map((element, i) => {
        if (index === i) {
          element.open = !element.open
        } else {
          element.open = false
        }
        return element;
      });
    }
  }
};
</script>
